import React from 'react';
import { CardHeader, Tooltip } from '@mui/material';
import { GridActionsCellItem } from '@mui/x-data-grid-pro';
import SearchIcon from '@mui/icons-material/Search';
import HistorySearchIcon from '@mui/icons-material/YoutubeSearchedFor';

import { DataGrid, PageTitleWithToolTip } from '../Common';
import { StyledCellLink } from '../Common/DataGrid/CellComponents';
import { text_commonCellProps } from '../Common/DataGrid/utils';
import { getDateRangeFilterOperator } from '../Common/DataGrid/FilterComponents';

import { Grey2 } from '../../color_utils';
import { useNavigate } from '../../hooks';
import Routes from '../../routes';

const dateRangeFilterOperator = getDateRangeFilterOperator({});

const columns = [
    {
        field: 'name',
        headerName: 'Asset name',
        ...text_commonCellProps,
        renderCell: ({ row: { name, id } }) => (
            <StyledCellLink
                path={`/Inventory/${id}`}
                text={name}
                from={window.location.pathname}
            />
        )
    },
    {
        field: 'locationOnSite',
        headerName: 'Location on site',
        ...text_commonCellProps
    },
    {
        field: 'roomArea',
        headerName: 'Room/Area',
        ...text_commonCellProps
    },
    {
        field: 'status',
        headerName: 'Status',
        ...text_commonCellProps
    },
    {
        field: 'statusDate',
        headerName: 'Status date',
        filterOperators: dateRangeFilterOperator
    },
    {
        field: 'category',
        headerName: 'Category',
        ...text_commonCellProps
    },
    {
        field: 'type',
        headerName: 'Type',
        ...text_commonCellProps
    },
    {
        field: 'serialNumber',
        headerName: 'Serial number',
        ...text_commonCellProps
    },
    {
        field: 'tagNumber',
        headerName: 'Tag number',
        ...text_commonCellProps
    },
]

const InventoryGeneral = ({
    id,
}) => {

    const navigate = useNavigate({
        pageName: "inventoryGeneral"
    });

    const actionRow = {
        type: 'actions',
        field: 'Quick Actions',
        width: 100,
        getActions: ({ row }) => {

            const { id } = row;
            const quickActions = [
                <GridActionsCellItem
                    icon={
                        <Tooltip
                            title="View Asset"
                        >
                            <SearchIcon sx={{ color: Grey2 }} />
                        </Tooltip>
                    }
                    onClick={() => navigate.push(`/Inventory/${id}`)}
                />,
                <GridActionsCellItem
                    icon={
                        <Tooltip
                            title="View History"
                        >
                            <HistorySearchIcon sx={{ color: Grey2 }} />
                        </Tooltip>
                    }
                    onClick={() => navigate.push(`/Inventory/${id}#History`)}
                />
            ];

            return quickActions;
        }
    }

    return (
        <>
            <DataGrid
                url={Routes.Location.InventoryTable(id, false, false, false, false)}
                noResultText="Oops...It is empty here..."
                noResultText2="Create a new General Asset or change your search criteria."
                columns={[...columns, actionRow]}
                headerContent={
                    <CardHeader
                        title={
                            <PageTitleWithToolTip
                                pageTitle={"General Inventory"}
                            />
                        }
                        sx={{
                            "& .MuiCardHeader-action": { display: "flex" },
                            "& .MuiCardHeader-content": { maxWidth: "100%", textWrap: "nowrap" }
                        }}
                    />
                }
                hideExportButton={true}
            />
        </>
    );
}

export default InventoryGeneral;
